import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOskInternalExamSettingsVm } from '../osk-internal-exam-settings-vm.model';
import { IOskInternalExamSettingsIm } from '../osk-internal-exam-settings-im.model';
import { IOskInternalExamSettingsUm } from '../osk-internal-exam-settings-um.model';

@Injectable({ providedIn: 'root' })
export class OskInternalExamSettingsService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OskInternalExamSettings`;
  }

  get(): Observable<IOskInternalExamSettingsVm> {
    const headers = this.createHeaders();
    return this.http.get<IOskInternalExamSettingsVm>(this.baseUrl, { headers });
  }

  post(
    oskInternalExamSettingsIm: IOskInternalExamSettingsIm,
  ): Observable<IOskInternalExamSettingsVm> {
    const headers = this.createHeaders();
    return this.http.post<IOskInternalExamSettingsVm>(
      this.baseUrl,
      oskInternalExamSettingsIm,
      { headers },
    );
  }

  put(
    oskInternalExamSettingsUm: IOskInternalExamSettingsUm,
  ): Observable<IOskInternalExamSettingsVm> {
    const headers = this.createHeaders();
    return this.http.put<IOskInternalExamSettingsVm>(
      this.baseUrl,
      oskInternalExamSettingsUm,
      { headers },
    );
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
